var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.backToCase}},[_vm._v("Back")]),(_vm.intakeStatus)?_c('PatientIntakeForm',{attrs:{"intakeStatus":_vm.intakeStatus}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }